import React from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  InputBase,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Divider,
  Card,
  CardHeader,
  CardContent,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import EditIcon from "@mui/icons-material/Edit";
import GetAppIcon from "@mui/icons-material/GetApp";
import AddIcon from "@mui/icons-material/Add";

const VendorRFQ = () => {
  // Sample data for RFQs
  const rfqs = [
    { 
      id: "RFQ-2024-0001", 
      date: "Mar 11, 2024",
      items: 7,
      dueDate: "Mar 21, 2024",
      status: "Draft"
    },
    { 
      id: "RFQ-2024-0002", 
      date: "Mar 12, 2024",
      items: 9,
      dueDate: "Mar 22, 2024",
      status: "Quoted"
    },
    { 
      id: "RFQ-2024-0003", 
      date: "Mar 13, 2024",
      items: 2,
      dueDate: "Mar 23, 2024",
      status: "Pending Response"
    },
    { 
      id: "RFQ-2024-0004", 
      date: "Mar 14, 2024",
      items: 5,
      dueDate: "Mar 24, 2024",
      status: "Quoted"
    },
    { 
      id: "RFQ-2024-0005", 
      date: "Mar 15, 2024",
      items: 1,
      dueDate: "Mar 25, 2024",
      status: "Draft"
    },
  ];

  const getStatusColor = (status) => {
    switch(status) {
      case "Draft":
        return { bg: "#E0E7FF", color: "#4F46E5" };
      case "Quoted":
        return { bg: "#DCFCE7", color: "#10B981" };
      case "Pending Response":
        return { bg: "#FEF3C7", color: "#F59E0B" };
      default:
        return { bg: "#F3F4F6", color: "#6B7280" };
    }
  };

  return (
    <div className="page-container">
      <Card
        className="shadow-sm"
        variant="outlined"
        sx={{
          border: "1px solid lightgray",
          borderRadius: "10px",
          width: "100%",
        }}
      >
        <CardHeader
          title={<Typography variant="h5" sx={{ fontWeight: 400, fontSize: '24px', color: '#333' }} className="font-rubik">RFQ</Typography>}
          action={
            <div>
              <Button
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ 
            bgcolor: '#050092', 
            '&:hover': { bgcolor: '#4338CA' },
            borderRadius: '8px',
            textTransform: 'none',
            display: { xs: 'none', sm: 'flex' },

          }}
        >
          New RFQ
        </Button>
            </div>
          }
          sx={{
            margin: "15px",
            display: "flex",
            justifyContent: "space-between",
          }}
        />
        <Divider sx={{ backgroundColor: "darkgray" }} />
      
      <CardContent>

      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
          <Paper
            component="form"
            sx={{ 
              p: '2px 4px', 
              display: 'flex', 
              alignItems: 'center', 
              width: 250,
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              boxShadow: 'none'
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search RFQs..."
              inputProps={{ 'aria-label': 'search rfqs' }}
            />
            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
              <SearchIcon />
            </IconButton>
          </Paper>

          <Button
            variant="outlined"
            startIcon={<FilterListIcon />}
            sx={{ 
              borderColor: '#e0e0e0',
              color: '#6B7280',
              textTransform: 'none',
              borderRadius: '8px',
            }}
          >
            Filter
          </Button>
        </Box>

       
      </Box>

      <TableContainer component={Paper} sx={{ boxShadow: 'none', border: '1px solid #f0f0f0', borderRadius: '8px' }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead sx={{ backgroundColor: '#f9fafb' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', color: '#6B7280', fontFamily: 'Rubik' }}>RFQ ID</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#6B7280', fontFamily: 'Rubik' }}>DATE</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#6B7280', fontFamily: 'Rubik' }}>ITEMS</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#6B7280', fontFamily: 'Rubik' }}>DUE DATE</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#6B7280', fontFamily: 'Rubik' }}>STATUS</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#6B7280', fontFamily: 'Rubik' }}>ACTIONS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rfqs.map((rfq) => {
              const statusStyle = getStatusColor(rfq.status);
              return (
                <TableRow key={rfq.id} hover>
                  <TableCell component="th" scope="row">
                    <Typography variant="body2" sx={{ fontWeight: 'medium', color: '#111827', fontFamily: 'Rubik' }}>
                      {rfq.id}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ color: '#6B7280', fontFamily: 'Rubik' }}>
                      {rfq.date}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ color: '#6B7280', fontFamily: 'Rubik' }}>
                      {rfq.items} items
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ color: '#6B7280', fontFamily: 'Rubik' }}>
                      {rfq.dueDate}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip 
                      label={rfq.status} 
                      sx={{ 
                        bgcolor: statusStyle.bg, 
                        color: statusStyle.color,
                        fontWeight: 'medium',
                        borderRadius: '16px',
                        fontSize: '0.75rem',
                        height: '24px'
                      }} 
                    />
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <IconButton size="small" sx={{ color: '#6B7280' }}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton size="small" sx={{ color: '#6B7280' }}>
                        <GetAppIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      </CardContent>
      </Card>
    </div>
  );
};

export default VendorRFQ;
